import { type CloudinaryTransformOptions } from '#app/utilities/cloudinaryTransforms/types.js';
import { getContraImageUrl } from './getContraImageUrl.js';

const BASE_IMAGE_TRANSFORM: CloudinaryTransformOptions = {
  crop: 'fill',
  format: 'avif',
  quality: 'auto:good',
};

export const getImageAttributes = ({
  grayscale = false,
  height,
  imageTransforms,
  uid,
  width,
}: {
  grayscale?: boolean;
  height: number;
  imageTransforms?: Omit<CloudinaryTransformOptions, 'height' | 'width'>;
  uid: string;
  width: number;
}): {
  src: string;
  srcSet: string;
} => {
  const source = getContraImageUrl(uid, {
    ...BASE_IMAGE_TRANSFORM,
    ...imageTransforms,
    height,
    width,
  });

  // https://developer.mozilla.org/en-US/docs/Learn/HTML/Multimedia_and_embedding/Responsive_images#resolution_switching_same_size_different_resolutions
  const sourceSet = [
    source + ' 1x',
    getContraImageUrl(uid, {
      ...BASE_IMAGE_TRANSFORM,
      ...imageTransforms,
      effect: grayscale ? 'grayscale' : undefined,
      height: height * 2,
      width: width * 2,
    }) + ' 2x',
  ].join(', ');

  return {
    src: source,
    srcSet: sourceSet,
  };
};
